function UserAddSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15.878"
      height="15.779"
      viewBox="0 0 15.878 15.779"
    >
      <g
        id="Group_1924"
        data-name="Group 1924"
        transform="translate(-6714.617 -3413.368)"
      >
        <path
          id="Path_435"
          data-name="Path 435"
          d="M34.165,26.211a3.831,3.831,0,1,0-5.059,0A6.11,6.11,0,0,0,25.5,31.795c0,.726.376,1.728,2.179,2.379a11.545,11.545,0,0,0,3.957.6c4.533,0,6.135-1.6,6.135-2.98A6.11,6.11,0,0,0,34.165,26.211ZM31.635,21a2.329,2.329,0,1,1-2.329,2.329A2.329,2.329,0,0,1,31.635,21Zm0,12.27c-2.73,0-4.633-.776-4.633-1.477a4.633,4.633,0,0,1,9.266,0C36.268,32.5,34.365,33.272,31.635,33.272Z"
          transform="translate(6689.117 3394.369)"
          fill="#373334"
        />
        <path
          id="Path_436"
          data-name="Path 436"
          d="M72.931,19.277H71.9V18.25a.751.751,0,0,0-.751-.751.726.726,0,0,0-.751.751v1.027H69.35a.751.751,0,0,0-.751.751.726.726,0,0,0,.751.751H70.4v1.052a.726.726,0,0,0,.751.751.751.751,0,0,0,.751-.751V20.779h1.027a.726.726,0,0,0,.751-.751A.751.751,0,0,0,72.931,19.277Z"
          transform="translate(6656.813 3395.87)"
          fill="#373334"
        />
      </g>
    </svg>
  );
}
export default UserAddSvg;